'use client';

import { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';

interface SanitizedHTMLProps {
  html: string;
  className?: string;
  style?: React.CSSProperties;
}

export default function SanitizedHTML({ html, className, style }: SanitizedHTMLProps) {
  const [sanitized, setSanitized] = useState(() => {
    if (!html) return '';
    return html.replace(/&nbsp;|\u00a0/g, ' ');
  });

  useEffect(() => {
    if (!html) {
      setSanitized('');
      return;
    }
    const normalizedHtml = html.replace(/&nbsp;|\u00a0/g, ' ');
    const purify = typeof DOMPurify === 'function' ? DOMPurify(window) : DOMPurify;
    if (purify && typeof purify.sanitize === 'function') {
      setSanitized(purify.sanitize(normalizedHtml));
    } else {
      setSanitized(normalizedHtml);
    }
  }, [html]);

  return (
    <div
      className={`${className || ''} break-words w-full`}
      style={style}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}
